// extracted by mini-css-extract-plugin
export default {"shareButton":"ShareButton-module_shareButton-eowqq"};